import React from 'react'
import { Brand } from '../../../types/brand'

interface BrandCardProps {
  brand: Brand
  onBrandClick: (id: number) => void
}

const BrandCard: React.FC<BrandCardProps> = ({ brand, onBrandClick }) => {
  return (
    <div
      className='brand-card cursor-pointer'
      onClick={() => onBrandClick(brand.id)}
      style={{ cursor: 'pointer' }}
    >
      <div className='brand-card__img'>
        <img
          src={brand.image || '/assets/images/brand-placeholder.jpg'}
          alt={brand.name}
          className='img-fluid'
        />
      </div>
      <div className='brand-card__body'>
        <h5 className='brand-card__title'>{brand.name}</h5>
      </div>
    </div>
  )
}

export default BrandCard
